/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Pass_UnpaidInputs */

const en_platform_pass_unpaid = /** @type {(inputs: Platform_Pass_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unpaid`)
};

const pl_platform_pass_unpaid = /** @type {(inputs: Platform_Pass_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zalega`)
};

/**
* | output |
* | --- |
* | "Unpaid" |
*
* @param {Platform_Pass_UnpaidInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_pass_unpaid = /** @type {((inputs?: Platform_Pass_UnpaidInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Pass_UnpaidInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_pass_unpaid(inputs)
	return en_platform_pass_unpaid(inputs)
});